import { Button, type ButtonProps, type PolymorphicComponentProps, Tooltip } from "@mantine/core";
import classes from "./styles.module.css";

export interface IconButtonProps extends PolymorphicComponentProps<"button", ButtonProps> {
    tooltip: string;
}
export function GuideNavButton({ children, tooltip, ...rest }: IconButtonProps) {
    return (
        <Tooltip label={tooltip}>
            <Button className={classes.disabledNavButton} variant="transparent" p="3xs" h="2rem" {...rest}>
                {children}
            </Button>
        </Tooltip>
    );
}
